/** The console's runtime configuration, written to /config.json by the deployment. */
export interface ConsoleConfig {
  region: string;
  userPoolId: string;
  userPoolClientId: string;
}

export async function loadConfig(): Promise<ConsoleConfig> {
  const response = await fetch("/config.json", { cache: "no-cache" });
  if (!response.ok) throw new Error(`Could not load /config.json (HTTP ${response.status}).`);
  return (await response.json()) as ConsoleConfig;
}
